/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {browserHistory} from 'react-router';
import * as pathConstants from '../../../constants/pathConstants';
import EstablishmentManagementForm from './EstablishmentManagementForm';
import * as establishmentActions from '../../../actions/establishmentActions';
import * as FormName from '../../../constants/formNameConstants';
import {searchForFormById} from '../../../selectors/searchForForm';
import confirmFormIsValid from './EstablishmentEditChecks';
import {createEstablishmentObject, createEmptyEstablishmentObject} from '../establishmentModel';
import {findNAICSCode} from '../NAICS/NaicsLookup';
import {NO_NAICS_DATA_RETURNED} from '../../../constants/errorMessages';
import checkStatePlanRules from './StatePlanRules';
import StatePlanMessages from './StatePlanMessages';
import '../../../styles/modals/statePlanModal.css';
// import {SUMMARY_DATA_NOT_REQUIRED_MESSAGE}  from '../../../constants/EstablishmentStatusEnumeration';
import {createApiPathWithQueryStrings} from '../../../api/fetch/fetchServices';
import * as apiConstants from '../../../constants/apiConstants';

export class EstablishmentManagementPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      establishment: Object.assign({}, this.props.establishment),
      formIsValid: !!this.props.establishment.id,
      establishmentForm: this.props.establishmentForm,
      formName: this.props.formName,
      activeFields: [],
      errors: {},
      hideNAICSDropDown: true,
      statePlanRules: this.props.statePlanRules,
      statePlanSpecialMessage: null,
      statePlanMessages: [],
      repeatedEstablishment: null,
      showStateModal: false,
      naicsLoading: false,
      initialNaicsSearch: [],
      currentNaicsCodes: [],
      previousInput: "",
    };

    this.saveEstablishment = this.saveEstablishment.bind(this);
    this.enteringData = this.enteringData.bind(this);
    this.redirect = this.redirect.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.cancelChanges = this.cancelChanges.bind(this);
    this.enteringNAICSCode = this.enteringNAICSCode.bind(this);
    this.lookupNAICSCode = this.lookupNAICSCode.bind(this);
    this.selectNAICSCode = this.selectNAICSCode.bind(this);
    this.setActiveFields = this.setActiveFields.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.hideStateModal = this.hideStateModal.bind(this);
    this.checkIsRequiredToFile300a = this.checkIsRequiredToFile300a.bind(this);
  }

  componentDidMount() {
    if (!this.props.statePlanStates) {
      this.props.actions.loadStatePlanStates();
    }
    if(this.state.establishment.naics){
      let firstTwo = this.state.establishment.naics.substring(0,2);
      this.lookupNAICSCode(firstTwo);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.establishment.establishment_status == 2) {
      this.redirect(pathConstants.pathToPageNotFound);
    }
    if (nextProps.establishmentNotFound) {
      this.redirect(pathConstants.pathToAccessDenied);
    }
    if (this.props.establishment.id != nextProps.establishment.id) {
      // Necessary to populate form when existing course is loaded directly.
      this.setState({
        establishment: Object.assign({}, nextProps.establishment)
      });
    }
    if (this.props.establishmentForm != nextProps.establishmentForm) {
      this.setState({
        establishmentForm: Object.assign({}, nextProps.establishmentForm)
      });
    }
    if (this.props.statePlanRules != nextProps.statePlanRules) {
      this.setState({statePlanRules: nextProps.statePlanRules});
    }
  }

  // A custom function to check summary data requirment.
  checkIsRequiredToFile300a(naics_code, size) {
    let queryParams = {
      naics: naics_code,
      size: size,
    };
    let eligiblityCheckPath =
      createApiPathWithQueryStrings(apiConstants.summaryDataRequired, queryParams);
    fetch(eligiblityCheckPath)
      .then(response => response.json())
      .then(data => {
        const require_summary_data = data['require_summary_data'];
        if (require_summary_data == false) {
          // Don't show the popup for the 300a requirement based on
          // naics and org size.
          // let statePlanMessages = [{
          //   message: SUMMARY_DATA_NOT_REQUIRED_MESSAGE
          // }];
          // this.setState({
          //  statePlanMessages: statePlanMessages,
          //  showStateModal: true
          // });
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  enteringData(event) {
    event.preventDefault();
    const field = event.target.name;
    let rules = this.state.statePlanRules;
    let specialMessage = this.state.statePlanSpecialMessage;
    let establishment = this.state.establishment;
    if (field === "zipCode") {
      establishment[field] = handleZip(establishment.zipCode, event.target.value);
    } else {
      establishment[field] = event.target.value;
    }

    if (field === 'state' && this.props.statePlanStates) {
      const statePlanState = this.props.statePlanStates[event.target.value] || {};
      rules = statePlanState.rules || [];
      specialMessage = statePlanState.special_message || null;

      const statePlanMessages = checkStatePlanRules(establishment, rules, specialMessage, "state");

      this.setState({
        statePlanRules: rules,
        statePlanSpecialMessage: specialMessage,
        statePlanMessages: statePlanMessages,
        showStateModal: statePlanMessages.length > 0
      });
    }

    this.setActiveFields(field);

    const formValidity = confirmFormIsValid(this.state.establishment, this.state.activeFields, this.props.requiredFields, this.props.establishments);

    this.setState({formIsValid: formValidity.formIsValid, errors: formValidity.errors, establishment: establishment, repeatedEstablishment: formValidity.repeatedEstablishment});
  }

  handleClick(event) {
    const field = event.target.name;
    let establishment = this.state.establishment;
    establishment[field] = event.target.value;
    const rules = this.state.statePlanRules;
    const specialMessage = this.state.statePlanSpecialMessage;
    this.setActiveFields(field);

    const formValidity = confirmFormIsValid(this.state.establishment, this.state.activeFields, this.props.requiredFields, this.props.establishments);

    let statePlanMessages = [];

    if (field == 'size') {
      statePlanMessages = checkStatePlanRules(establishment, rules, specialMessage, "size");
    }

    if (field == 'establishmentType' || field == "type") {
      statePlanMessages = checkStatePlanRules(establishment, rules, specialMessage, "type");
    }

    // Do this only if statePlanMessages is empty. This will start a new async thread
    // and a setState.
    if (statePlanMessages.length == 0) {
      // When either naics or size changes, then run the logic for naics+size requirement.
      if (field == "size") {
        // Check the size and Naics code requirement if both are not empty.
        if (establishment['naicsCode'] != '' && establishment['size'] != undefined) {
          this.checkIsRequiredToFile300a(establishment['naicsCode'], establishment['size']);
        }
      }
    }
    else {
      // Set statePlanMessages state only if it has been set in the checkStatePlanRules
      // functions above. Else allow the separate fetch for naics to also set it independently.
      this.setState({
        statePlanMessages: statePlanMessages,
        showStateModal: true
      });
    }

    this.setState({
      establishment: establishment,
      formIsValid: formValidity.formIsValid,
      errors: formValidity.errors,
      repeatedEstablishment: formValidity.repeatedEstablishment
    });
  }

  saveEstablishment(event) {
    event.preventDefault();
    let establishment = this.props.establishment;
    let emptyEstablishment = true;
    let establishmentSummaryKeys = Object.keys(this.props.establishment);

    establishmentSummaryKeys.map((estabKey) => {
      if (establishment[estabKey] != '' && estabKey !== 'establishment_status' && estabKey !== 'naicsYear') {
        emptyEstablishment = false;
      }
    });
    this.setState({formIsValid: false});
    this.props.actions.saveEstablishment(this.state.establishment, this.props.establishmentId)
    .then((establishmentId) => {
      this.redirect(establishmentId, emptyEstablishment);
    })
    .catch(error => {
      this.setState({formIsValid: true});
      throw(error);
    });
  }

  cancelChanges(event) {
    event.preventDefault();
    let extension = (this.props.establishment.id) ? '/' + this.props.establishment.id : '';
    browserHistory.push(pathConstants.pathToEstablishmentsDashboardPage + extension);
  }

  redirect(id, emptyEstablishment) {
    if (emptyEstablishment !== '' && emptyEstablishment !== 'undefined' && id) {
      browserHistory.push({
        pathname: pathConstants.pathToEstablishmentsDashboardPage + '/' + id,
        state: {
          successMsg: "Successful",
          emptyEstablishment: emptyEstablishment
        }
      });
    } else if (id) {
      browserHistory.push({
        pathname: pathConstants.pathToEstablishmentsDashboardPage + '/' + id,
        state: {
          successMsg: "Successful"
        }
      });
    } else {
      browserHistory.push(pathConstants.pathToEstablishmentsDashboardPage);
    }
  }

  enteringNAICSCode(event) {
    event.preventDefault();
    let input = event.target.value;
    input = input.replace(/^\s+/g, '');

    let establishment = this.state.establishment;
    let initialNaicsSearch = this.state.initialNaicsSearch;
    let currentNaicsCodes = this.state.currentNaicsCodes;
    let errors = this.state.errors;
    let previousInput = this.state.previousInput;

    establishment.naics = input;

    if (input.length < previousInput.length && establishment.naicsCode) {
      establishment.naicsCode = '';
    }

    if(input.length==2 || (input.length==previousInput.length && input!=previousInput)
      || (input.length>2 && initialNaicsSearch.length==0)){

      this.setState({
        hideNAICSDropDown: false,
        naicsLoading: true
      });

      this.lookupNAICSCode(input);
    }else if (input.length>=2 && previousInput.length!=input.length && initialNaicsSearch.length!=0){
      let filteredNaics = [];
      let hideDropDown = false;

      if(previousInput.length < input.length){
        filteredNaics = findNAICSCode(input, currentNaicsCodes);
      }else{
        filteredNaics = findNAICSCode(input, initialNaicsSearch);
      }

      if (filteredNaics.length === 0) {
        errors.naics = NO_NAICS_DATA_RETURNED;
        establishment.naicsIsInvalid = true;
        hideDropDown = true;
      }

      this.setState({
        currentNaicsCodes: filteredNaics,
        hideNAICSDropDown: hideDropDown,
        errors: errors,
        establishment: establishment,
        previousInput: input
      });
    }else if(input.length>0 && input==previousInput){
      this.setState({
        hideNAICSDropDown: false,
      });
    }else if(input.length < 2 &&
      (!initialNaicsSearch.length==0 || !currentNaicsCodes.length==0)){
      this.props.actions.clearNaicsCodes();
      this.setState({
        initialNaicsSearch: [],
        currentNaicsCodes: [],
        hideNAICSDropDown: true,
        establishment: establishment
      });
    }

    this.setActiveFields('naicsCode');
    this.setState({
      establishment: establishment,
      previousSearch: input
    });
  }

  lookupNAICSCode(input){
    let establishment = this.state.establishment;
    let initialNaicsSearch = this.state.initialNaicsSearch;
    let currentNaicsCodes = this.state.currentNaicsCodes;
    let errors = this.state.errors;
    let formIsValid = this.state.formIsValid;

    this.props.actions.loadNaicsCodes(input)
    .then(data => {
      if (data.length === 0 || data.message) {
        errors.naics = NO_NAICS_DATA_RETURNED;
        formIsValid = false;
        establishment.naicsIsInvalid = true;
      }else{
        errors.naics = "";
        initialNaicsSearch = data;
        currentNaicsCodes = data;
      }

      this.setState({
        initialNaicsSearch: initialNaicsSearch,
        currentNaicsCodes: currentNaicsCodes,
        naicsLoading: false,
        errors: errors,
        formIsValid: formIsValid,
        establishment: establishment,
        previousInput: input
      });
    })
    .catch(error => {
      throw(error);
    });
  }

  selectNAICSCode(event) {
    event.preventDefault();
    let establishment = this.state.establishment;

    if(event.target.name && establishment.naicsCode!=event.target.name){
      establishment.naicsCode = event.target.name;
      this.state.errors.naics = '';
    }
    if(event.target.id && establishment.industryDescription!=event.target.id){
      establishment.industryDescription = event.target.id;
    }
    establishment.naicsIsInvalid = true;
    if(establishment.naicsCode && establishment.industryDescription){
      if(establishment.naics.indexOf(establishment.industryDescription)===-1){
        establishment.naics = establishment.naicsCode + " " + establishment.industryDescription;
      }
      establishment.naicsIsInvalid = false;
    }
    this.props.actions.clearNaicsCodes();
    let formIsValidObject = confirmFormIsValid(this.state.establishment, this.state.activeFields,
      this.props.requiredFields, this.props.establishments);
      this.setState({
        establishment: establishment,
        hideNAICSDropDown: true,
        formIsValid: formIsValidObject.formIsValid,
        errors: formIsValidObject.errors,
      });
    }

    handleOnFocus() {
      this.setState({hideNAICSDropDown: true});
    }

    handleOnBlur(event) {
      event.preventDefault();
      const field = event.target.name;
      this.setActiveFields(field);

      let relatedTarget = event.relatedTarget || document.activeElement; // IE method

      let enteredNAICSCode = event.target.value;
      let naicsDescription = "";
      let naicsWasSelected = false;
      if(relatedTarget){
        if(relatedTarget.name){
          const relatedName = relatedTarget.name;
          if(relatedName){
            let canParse = !isNaN(relatedName);
            if(canParse){
              enteredNAICSCode = parseInt(relatedName);
              naicsDescription = relatedTarget.id;
              naicsWasSelected = true;
            }
          }
        }
      }

      let isNaics = false;
      if(field && event.target.name=="naics"){
        isNaics = true;
      }

      if(isNaics || naicsWasSelected){
        event.target.name = enteredNAICSCode;
        event.target.id = naicsDescription;
        this.selectNAICSCode(event);
        event.target.name = "";
        event.target.id = "";
      }

      if(this.state.errors.naics && this.state.errors.naics.length > 0){
        this.setState({
          formIsValid: false,
          errors: this.state.errors,
          hideNAICSDropDown: true,
        });
      }else{
        const formIsValidObject = confirmFormIsValid(this.state.establishment, this.state.activeFields,
          this.props.requiredFields, this.props.establishments);
        this.setState({
          formIsValid: formIsValidObject.formIsValid,
          errors: formIsValidObject.errors,
          hideNAICSDropDown: true,
        });
      }
    }

    setActiveFields(field) {
      let activeFields = this.state.activeFields;
      if (activeFields.indexOf(field) == -1) {
        activeFields.push(field);
        this.setState({activeFields: activeFields});
      }
    }

    hideStateModal() {
      this.setState({showStateModal: false});
    }

  render() {
    return (
      <div>
        <StatePlanMessages
          messages={this.state.statePlanMessages}
          showModal={this.state.showStateModal}
          hideModal={this.hideStateModal}/>
        <EstablishmentManagementForm
          form={this.state.establishmentForm}
          removalForm={this.state.removalForm}
          establishment={this.state.establishment}
          onSubmit={this.saveEstablishment}
          onCancel={this.cancelChanges}
          onChange={this.enteringData}
          onClick={this.handleClick}
          submitStatus={this.state.formIsValid}
          errors={this.state.errors}
          repeatedEstablishment={this.state.repeatedEstablishment}
          enteringNAICSCode={this.enteringNAICSCode}
          hideNAICSDropDown={this.state.hideNAICSDropDown}
          onSelectNAICSOptions={this.selectNAICSCode}
          NAICSOptions={this.state.currentNaicsCodes}
          naicsLoading={this.state.naicsLoading}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}/>
      </div>
    );
  }
}

EstablishmentManagementPage.propTypes = {
  actions: PropTypes.object.isRequired,
  establishment: PropTypes.object.isRequired,
  establishments: PropTypes.array,
  establishmentForm: PropTypes.object.isRequired,
  establishmentId: PropTypes.string,
  formName: PropTypes.string.isRequired,
  requiredFields: PropTypes.array,
  user: PropTypes.object,
  statePlanStates: PropTypes.object,
  statePlanRules: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  naicsCodes: PropTypes.array,
  establishmentNotFound: PropTypes.bool
};

function getEstablishmentById(establishments, id) {
  const establishment = establishments.filter(establishment => establishment.id == id);
  if (establishment) {
    return establishment[0];
  }
  return null;
}

function mapStateToProps(state, ownProps) {
  const establishmentId = ownProps.params.id;
  let statePlanStates = null;
  let statePlanRules = null;
  let establishment = createEmptyEstablishmentObject();
  let establishments = state.establishments;
  let requiredFields = [];
  let establishmentForm = {};
  let formName = FormName.itaCreateEstablishment;
  let establishmentNotFound = false;

  if (state.forms.length > 0) {
    establishmentForm = searchForFormById(state.forms, FormName.establishmentFormId);
  }

if (establishmentForm && establishmentForm.formQuestions) {
    requiredFields = []
    .concat
    .apply([], establishmentForm.formQuestions.map(question => {
      return question
      .questionParts
      .map(questionPart => {
        if (questionPart.questionPartRequired == '1') {
          return questionPart;
        }
      })
      .filter(questionPart => {
        return questionPart;
      });
    }));
  }

  let retrievedEstablishment;

  if (establishmentId && state.establishments.length > 0) {
    retrievedEstablishment = getEstablishmentById(state.establishments, establishmentId);
  }

  if (retrievedEstablishment) {
    establishment = createEstablishmentObject(retrievedEstablishment);
    establishment.naicsIsInvalid = false;
    establishments = establishments.filter(estab => {
      return estab.id !== establishment.id;
    });
  } else if (!retrievedEstablishment && establishmentId) {
    establishmentNotFound = true;
  }

  if (state.statePlanStates) {
    statePlanStates = state.statePlanStates;
  }

  if (statePlanStates && establishment.state) {
    statePlanRules = statePlanStates[establishment.state] || [];
  }

  let naicsCodes = [];
  if (state.naicsCodes) {
    naicsCodes = state.naicsCodes;
  }

  return {
    establishment: establishment,
    establishments: establishments,
    establishmentForm: establishmentForm,
    establishmentId: establishmentId,
    formName: formName,
    requiredFields: requiredFields,
    user: state.user[state.user.length - 1] || {},
    statePlanStates: statePlanStates,
    statePlanRules: statePlanRules,
    naicsCodes: naicsCodes,
    establishmentNotFound: establishmentNotFound
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(establishmentActions, dispatch)
  };
}

function handleZip(zipSoFar, incomingZip) {
  if (incomingZip.length === 6 && incomingZip.slice(-1) !== "-") {
    incomingZip = zipSoFar + '-' + incomingZip.slice(-1);
  }
  if (incomingZip.length === 6 && incomingZip.slice(-1) === '-') {
    incomingZip = incomingZip.substring(0, incomingZip.length - 1);
  }
  return incomingZip;
}

export default connect(mapStateToProps, mapDispatchToProps)(EstablishmentManagementPage);



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentManagement/EstablishmentManagementPage.js
 **/